// src/components/HydraulicControlCards.js
import React from 'react';
import './Hydraulic.css';
import hydraulicImg from '../../../imgs/hydraulic.webp'; 
import controlImg from '../../../imgs/control.webp';     
const Hydraulic = () => {
  return (
    <div className="hydr-container">
      <div className="hydr"data-aos="fade-down-right">
        <img src={hydraulicImg} alt="Hydraulic System" className="hydr-img" />
        <div className="hydr-content">
          <h2>HYDRAULIC SYSTEM</h2>
          <ul>
            <li>New servo system applications ensures machine power to increase more than 10%.</li>
            <li>Reasonable and orderly piping layout, significantly reducing loss in oil channel.</li>
            <li>Oil circuit consists of standard components, improving the reliability of hydraulic system.</li>
          </ul>
        </div>
      </div>

      {/* Control System Card */}
      <div className="hydr"data-aos="fade-down-left">
        <img src={controlImg} alt="Control System" className="hydr-img" />
        <div className="hydr-content">
          <h2>CONTROL SYSTEM</h2>
          <ul>
            <li>More reasonable electric circuit layout, improving anti-interference ability and stability.</li>
            <li>Central (network) management system interface, easy for production management.</li>
            <li>More powerful software, friendly to extension.</li>
            <li>Optimized control system, energy saving and high response.</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Hydraulic;
